module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJmYWNlYm9vayIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDIwIDIwIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPi5zdDB7ZmlsbDojRkZGRkZGO308L3N0eWxlPjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xMy4zLDUuOGgtMS4yYy0wLjksMC0xLjEsMC40LTEuMSwxLjF2MS40aDIuMmwtMC4zLDIuM2gtMS45djUuN0g4Ljd2LTUuN0g2LjhWOC4zaDEuOVY2LjcgYzAtMS45LDEuMi0yLjksMi44LTIuOWMwLjgsMCwxLjUsMC4xLDEuOCwwLjFWNS44eiIvPjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/img/facebook.svg
// module id = 250
// module chunks = 35783957827783 162898551421021